import { Component, Input } from '@angular/core';
import { User } from '@shared/models';

@Component({
  selector: 'gcc-user-tile',
  templateUrl: './user-tile.component.html',
  styleUrls: ['./user-tile.component.scss']
})
export class UserTileComponent {
  @Input() public user: User;
}
